import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminInterventionsContent from "../admin/components/AdminInterventionsContent";

const SupportExecutiveIntervention = () => {
  return (
    <SupportLayout userRole="SE">
      <AdminInterventionsContent useOwnLayout={false} userRole="SE" />
    </SupportLayout>
  );
};

export default SupportExecutiveIntervention;
